import { IEndpointConfiguration } from '@kurtosys/types/api/common/IEndpointConfiguration.js';
import {
	IServiceResponse,
	TPortfolioGetCorrelationMatrixRequest,
	TPortfolioGetCorrelationMatrixResponse,
} from '@kurtosys/types/portal/index.js';

import { KsysRequest } from '../KsysRequest.js';

export class PortfolioGetCorrelationMatrix extends KsysRequest<
	TPortfolioGetCorrelationMatrixRequest,
	IServiceResponse<TPortfolioGetCorrelationMatrixResponse>
> {
	getExplicitEndpoint = (): string => '/portal/portfolio/getCorrelationMatrix';
	get endpointConfiguration(): IEndpointConfiguration<any> {
		return this.getEndpointConfiguration('portal', 'PortfolioGetCorrelationMatrix');
	}
}
